
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Nouvelle entreprise : la stratégie pour bien communiquer",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les meilleures stratégies de communication pour une nouvelle entreprise afin de créer des liens avec vos clients et construire une image de marque solide.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Nouvelle entreprise : comment communiquer avec vos clients ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous lancez votre entreprise ? Cet article vous explique comment communiquer efficacement avec vos clients !",
        },
      ],
    };
  },
};
